const TIPOS_IMAGEM = [
  {
    description: 'Imagens',
    accept: {
      'image/*': ['.png', '.jpg', '.jpeg', '.webp', '.gif', '.bmp', '.heic', '.heif'],
    },
  },
];

export async function abrirSeletorImagem({ inputRef, onFileSelecionado }) {
  if (typeof window !== 'undefined' && typeof window.showOpenFilePicker === 'function') {
    try {
      const [handle] = await window.showOpenFilePicker({
        multiple: false,
        excludeAcceptAllOption: false,
        types: TIPOS_IMAGEM,
      });

      const arquivo = await handle?.getFile?.();
      if (arquivo) {
        onFileSelecionado(arquivo);
      }
      return;
    } catch (error) {
      if (error?.name === 'AbortError') {
        return;
      }

      console.warn('Falha ao abrir seletor nativo de imagem. Aplicando fallback.', error);
    }
  }

  if (!inputRef?.current) return;
  inputRef.current.value = '';
  inputRef.current.click();
}

function criarArquivoDeImagem(blob) {
  const extensao = String(blob.type || 'image/png').split('/')[1] || 'png';
  return new File([blob], `imagem-colada-${Date.now()}.${extensao}`, {
    type: blob.type || 'image/png',
  });
}

export function obterImagemDoEventoDeColagem(evento) {
  const itens = Array.from(evento?.clipboardData?.items || []);
  const itemImagem = itens.find((item) => item.type?.startsWith('image/'));
  const arquivo = itemImagem?.getAsFile?.();

  return arquivo || null;
}

export async function obterImagemDaAreaDeTransferencia() {
  if (typeof navigator === 'undefined' || !navigator.clipboard?.read) {
    throw new Error('Leitura da area de transferencia indisponivel neste navegador.');
  }

  const itens = await navigator.clipboard.read();
  for (const item of itens) {
    const tipoImagem = item.types.find((tipo) => tipo.startsWith('image/'));
    if (tipoImagem) {
      return criarArquivoDeImagem(await item.getType(tipoImagem));
    }
  }

  return null;
}
